import { apiSlice } from "../apiSlice/apiSlice";

export const expenseItemApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createExpenseItem: builder.mutation({
      query: (name) => ({
        url: "/expenseItems/createExpenseItem",
        method: "POST",
        body: {name},
      }),
      invalidatesTags: ["ExpenseItem"],
    }),

     updateExpenseItem: builder.mutation({
      query: ({name,id}) => ({
        url: "/expenseItems/updateExpenseItem",
        method: "PATCH",
        body: {name,id},
      }),
      invalidatesTags: ["ExpenseItem"],
    }),


    getExpenseItems: builder.query({
      query: ({page=1,search="",limit=10}={}) => ({
        url: `/expenseItems/getExpenseItems?page=${page}&search=${search}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["ExpenseItem"],
    }),

     getAllExpenseItems: builder.query({
      query: () => ({
        url: `/expenseItems/getAllExpenseItems`,
        method: "GET",
      }),
      providesTags: ["ExpenseItem"],
    }),


  }),
});

export const {
 useCreateExpenseItemMutation,
 useGetExpenseItemsQuery,
 useUpdateExpenseItemMutation,
 useGetAllExpenseItemsQuery
} = expenseItemApi;
